import { motion } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from "react-router-dom";
import HomeSVG from './images/images-home/HomeSVG';
import BackArrow from './images/images-home/BackArrow';


const GenericContentComp = ({content, isInIFrame}) => {

    const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1350px)'})

    const navigate = useNavigate()

    return (  
        <div className="genericContent-container">

            {isDesktopOrLaptop &&
                <motion.div className='genericContent-innerContainer'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5, duration: 1 }}
                    style={{
                        height: isInIFrame ? '100vh' : '',
                        top: isInIFrame ? '0px' : '',
                        scrollbarColor: isInIFrame ? 'auto' : ''
                    }}
                >
                    
                    {!isInIFrame &&
                    <div className='homeIcon-iframeContainer'
                        onClick={() => navigate('-1')}
                        style={{
                            position: 'fixed',
                            top: '81px',
                            left: '30px',
                            zIndex: 99,
                            cursor: 'pointer'
                        }}
                    >
                        <HomeSVG size={"2em"} color={"#ffffff"}/>
                    </div>
                    }

                    {isInIFrame &&  
                    <div className='homeIcon-iframeContainer'
                        onClick={() => navigate('-1')}
                        style={{
                            position: 'fixed',
                            top: '11px',
                            right: '4%',
                            zIndex: 99,
                            cursor: 'pointer'
                        }}
                    >
                        <BackArrow />
                    </div>
                    }
                    
                    <div className='genericContent-text' dangerouslySetInnerHTML={{__html: content}}></div>
                </motion.div>
            }


            {!isDesktopOrLaptop &&
                <motion.div className='genericContent-innerContainer'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5, duration: 1 }}
                    style={{
                        height: isInIFrame ? '100vh' : '(calc(100vh - 58px))',
                        top: isInIFrame ? '0px' : '58px',
                        scrollbarColor: isInIFrame ? 'auto' : ''
                    }}
                >

                    {(!isDesktopOrLaptop && isInIFrame) && 
                        <div className='homeIcon-iframeContainer'
                            onClick={() => navigate('-1')}
                            style={{
                                position: 'fixed',
                                top: '10px',
                                right: '5%',
                                zIndex: 99,
                                cursor: 'pointer'
                            }}
                        >
                            <BackArrow />
                        </div>
                    }

                    <div className='genericContent-text' dangerouslySetInnerHTML={{__html: content}}></div>
                </motion.div>
            }


        </div>
    );
}
 
export default GenericContentComp;